import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  textCheckbox: {
    marginLeft: 8,
  },
}));

export default useStyles;
